export default {"src":"/_next/static/media/BlossmLogoWhite.286ddc58.svg","height":82,"width":341,"blurWidth":0,"blurHeight":0};